import { useListagemContext } from 'context/ListagemContext';
import { LojaProps } from 'pages/compra/pedido/types';

export function useLojasFilter(): LojaProps[] {
    const { fullFilterData } = useListagemContext();
    const filterLoja = fullFilterData?.find((filter) => filter.value.property === 'idLoja');

    return filterLoja?.value.value || [];
}
